/*
Monotype Foundry Platform API
Version 1.0.0

Definition: Permissions

Properties:
  auth0UserId: string
  email: string
  name: string
  permissionIds: array
*/

var Permissions = (function () {
  function validatePermissions (arg) {
    // Validate auth0UserId
    if (arg.auth0UserId && !(typeof arg.auth0UserId === 'string')) {
      throw new Error('Permissions.auth0UserId: Wrong type: Got \'' + (typeof arg.auth0UserId) + '\', but expected: \'string\'')
    }
    // Validate email
    if (arg.email && !(typeof arg.email === 'string')) {
      throw new Error('Permissions.email: Wrong type: Got \'' + (typeof arg.email) + '\', but expected: \'string\'')
    }
    // Validate name
    if (arg.name && !(typeof arg.name === 'string')) {
      throw new Error('Permissions.name: Wrong type: Got \'' + (typeof arg.name) + '\', but expected: \'string\'')
    }
    // Validate permissionIds
    if (arg.permissionIds && !(Array.isArray(arg.permissionIds))) {
      throw new Error('Permissions.permissionIds: Wrong type: Got \'' + (typeof arg.permissionIds) + '\', but expected: \'array\'')
    }
  }
  function buildPermissions (arg) {
    var Permissions = arg
    // Complete auth0UserId
    // Expected Type: string
    Permissions.auth0UserId = Permissions.auth0UserId || ''
    // Complete email
    // Expected Type: string
    Permissions.email = Permissions.email || ''
    // Complete name
    // Expected Type: string
    Permissions.name = Permissions.name || ''
    // Complete permissionIds
    // Expected Type: array
    Permissions.permissionIds = Permissions.permissionIds || []
    return Permissions
  }
  return {
    validate: validatePermissions,
    build: buildPermissions
  }
})()

module.exports = Permissions
